import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
    root: {
      padding: theme.spacing(4),
    },
    content: {
      paddingTop: 150,
      textAlign: 'center',
    },
    image: {
      marginTop: 50,
      display: 'inline-block',
      maxWidth: '100%',
      width: 560,
    },
    title: {
      color: '#1a334d',
      fontSize: 20,
      fontWeight: 'bold',
      marginTop: theme.spacing(2.5),
    },
    subTitle: {
      color: '#1a334d',
      fontSize: 16,
      fontWeight: '300',
      marginTop: theme.spacing(1),
      '& a': {
        color: '#006cfc',
        cursor: 'pointer',
      },
    },
  }));